module.exports = __webpack_public_path__ + "img/check2-circle.beaa72a8.svg";